import {Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {
  ViewUserReportEditRequest
} from './view-user-report.types';
import {ChangeModalComponent} from './change-modal/change-modal.component';
import {
  SettingsSection,
  ViewUserReportRouteData
} from './view-user-report.option';

@Injectable()
export class ViewUserReportUiCoordinator {
  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute
  ) {}

  initialSection(): SettingsSection {
    const routeData = <ViewUserReportRouteData>this.route.snapshot.data;
    return routeData ? routeData.initialSettingsSection : undefined;
  }

  openEdit(request: ViewUserReportEditRequest): Promise<Object> {
    const modalRef = this.modalService.open(ChangeModalComponent);
    modalRef.componentInstance.action = request.action;
    modalRef.componentInstance.title = request.title;
    modalRef.componentInstance.obj = request.settings;
    modalRef.componentInstance.value = request.value;
    return modalRef.result;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-report/view-user-report-ui.coordinator.ts